import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {combineLatest, Observable, of} from 'rxjs';
import {DynamicAuthGuard} from './dynamic-auth.guard';
import {filter, switchMap, take} from 'rxjs/operators';
import {AuthStorageService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicTransactionTypeAuthGuard extends DynamicAuthGuard {
  constructor(
    protected authService: DcpAuthService,
    protected authStorageService: AuthStorageService,
    @Inject(PLATFORM_ID) public platformId: string,
  ) {
    super(authService, authStorageService, platformId);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.authStorageService.getToken(),
    ]).pipe(
      take(1),
      switchMap(([token]) => {
        if (isPlatformBrowser(this.platformId) && window.localStorage) {
          if (this.handleLoginConditions(token.access_token, true, state)) {
            return this.authService.isUserLoggedIn().pipe(
              filter((isLoggedIn) => isLoggedIn),
              take(1)
            );
          }
        }
        return of(true);
      })
    );
  }
}
